import React, { useState, useRef } from "react";
import "@/App.css";

import Navigation from "./components/Navigation";
import HeroSection from "./components/HeroSection";
import MembershipSection from "./components/MembershipSection";
import EcosystemSpaces from "./components/EcosystemSpaces";
import EventGallery from "./components/EventGallery";
import PlanRecommender from "./components/PlanRecommender";
import ValueNarrative from "./components/ValueNarrative";
import FinalCTA from "./components/FinalCTA";
import Footer from "./components/Footer";

function App() {
  const [isAnnual, setIsAnnual] = useState(false);

  const membershipRef = useRef(null);
  const quizRef = useRef(null);
  const spacesRef = useRef(null);

  const scrollToMembership = () => {
    membershipRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const scrollToQuiz = () => {
    quizRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const scrollToSpaces = () => {
    spacesRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="App min-h-screen bg-surface-dark" data-testid="app-container">
      <Navigation 
        onScrollToMembership={scrollToMembership} 
        onScrollToQuiz={scrollToQuiz}
        onScrollToSpaces={scrollToSpaces}
      />

      <main>
        <HeroSection 
          onScrollToMembership={scrollToMembership} 
          onScrollToQuiz={scrollToQuiz} 
        />

        <div ref={membershipRef}>
          <MembershipSection isAnnual={isAnnual} setIsAnnual={setIsAnnual} />
        </div>

        <EventGallery />

        <div ref={spacesRef}>
          <EcosystemSpaces />
        </div>

        <ValueNarrative />

        <div ref={quizRef}>
          <PlanRecommender />
        </div>

        <FinalCTA />
      </main>

      <Footer />
    </div>
  );
}

export default App;
